<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? 'Add Page' : 'Edit Page'}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? 'Add Page' : 'Edit Page'}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Page</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="pageAddForm" id="pageAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="type" class="form-label">Content Type:</label>
                    <select id="type" class="form-control" name="type" v-model="formData.type" :class="classes">
                      <option value="html">Html</option>
                      <option value="json">Json</option>
                    </select>
                  </ValidationProvider>
                  <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label  :for="'heading_title_l[' + language.code + ']'" class="form-label">Heading title:</label>
                      <input  :id="'heading_title_l[' + language.code + ']'" class="form-control" :name="'heading_title_l[' + language.code + ']'" v-model="formData.heading_title_l[language.code]" :class="checkValidation(classes)" placeholder="title" type="text">
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label  :for="'meta_title_l[' + language.code + ']'" class="form-label">Meta title:</label>
                      <input  :id="'meta_title_l[' + language.code + ']'" class="form-control" :name="'meta_title_l[' + language.code + ']'" v-model="formData.meta_title_l[language.code]" :class="checkValidation(classes)" placeholder="title" type="text">
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }"  tag="div" class="form-group">
                      <label :for="'meta_description_l[' + language.code + ']'" class="form-label">Meta Description:</label>
                      <textarea :id="'meta_description_l[' + language.code + ']'" class="form-control" :name="'meta_description_l[' + language.code + ']'" v-model="formData.meta_description_l[language.code]" :class="checkValidation(classes)" placeholder="meta description"></textarea>
                    </ValidationProvider>
                    <ValidationProvider v-if="formData.type === 'html'" v-slot="{ classes }" rules="" tag="div" class="form-group">
                      <label :for="'content_l[' + language.code + ']'" class="form-label">Content:</label>
                      <ckeditor  :class="checkValidation(classes, language.code)" v-model="formData.content_l[language.code]"  :name="'content_l[' + language.code + ']'"  :id="'content_l[' + language.code + ']'" :config="ckEditorConfig"></ckeditor>
                    </ValidationProvider>
                  </b-tab>
<!--                  <ImageUpload accept="image/png,image/jpeg,image/jpg" label="Meta Image:" name="image" uploadType="oneImage" type="image" :validation="true" :filesData="[formData.image]" />-->
                  <ValidationProvider v-slot="{ classes }" v-if="formData.type === 'json'" rules="required" tag="div" class="form-group">
                    <label for="content" class="form-label">Content:</label>
                    <v-jsoneditor id="content" v-model="formData.content_l"  :class="checkValidation(classes)" :options="options" name="content_l" :plus="true" height="400px"/>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="code" class="form-label">Slug:</label>
                    <input id="code" class="form-control" name="slug" v-model="formData.slug" placeholder="slug" :class="classes" type="text">
                  </ValidationProvider>
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import VJsoneditor from 'v-jsoneditor/src/index'
// import ImageUpload from '../../components/ImageUpload'
export default {
  name: 'CurrencyAdd',
  components: {
    VJsoneditor
    // ImageUpload
  },
  data () {
    return {
      ckEditorConfig: {
        // toolbar: [['Source', 'About', 'Styles', 'Format', 'Font', 'FontSize', 'Bold', 'Italic', 'Strikethrough', 'Heading', '|', 'Undo', 'Redo', '|', 'Link', 'BulletedList', 'NumberedList', 'BlockQuote', 'Image', 'Link', 'Unlink']],
        filebrowserImageUploadUrl: `${process.env.VUE_APP_WEB_API}image-upload`,
        fileTools_requestHeaders: {
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${localStorage.access_token}`
        }
      },
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      options: {
        mode: 'code'
      },
      formData: {
        type: 'html',
        content_l: {},
        meta_title_l: {},
        meta_description_l: {},
        heading_title_l: {},
        slug: ''
      },
      isCreate: false,
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state.pages.itemData
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.itemData
        if (this.formData.content_l.length === 0) {
          this.formData.content_l = {}
        }
      })
    }
  },
  methods: {
    ...mapActions({
      create: 'pages/create',
      update: 'pages/update',
      getData: 'pages/getData'
    }),
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.pageAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          // const form = document.getElementById('pageAddForm')
          // const formData = new FormData(form)
          // formData.append('content_l', JSON.stringify(this.formData.content_l))
          if (this.isCreate === true) {
            this.create(this.formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/pages')
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            this.update({ data: this.formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/pages')
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
